import useNetworkBlockUnlock from './useNetworkBlockUnlock';
import useNetworkReset from './useNetworkReset';
import useNicknameChange from './useNicknameChange';
import useSimcardReset from './useSimcardReset';
import useCrrBlockUnlock from './useCrrBlockUnlock';
import useUpload from './useUpload';
import useActivation from './useActivation';
import useHlrReprog from './useHlrReprog';
import useAlgarSuspension from './useAlgarSuspension';
import useSyncApn from './useSyncApn';
import useCancellation from './useCancellation';
import useOperatorRestriction from './useOperatorRestriction';
import useSimcardChange from './useSimcardChange';

const Common = {
  useUpload,
  useActivation,
  useNetworkReset,
  useNicknameChange,
  useSimcardReset,
  useCrrBlockUnlock,
  useNetworkBlockUnlock,
  useHlrReprog,
  useAlgarSuspension,
  useSyncApn,
  useCancellation,
  useOperatorRestriction,
  useSimcardChange,
};

export default Common;
